import { Box, Button, Grid, Popover, Stack, Typography, styled } from '@mui/material';
import React from 'react';

import WsColors from '../../WsColors';
import { WsButton } from '../WsButton';
import { WsTypoColors, WsTypography, WsTypoVariants } from '../WsTypography';

interface ButtonVariant {
  disableHover?: boolean;
}

const StyledButton = styled(Button)(({ disableHover = false }: ButtonVariant) => ({
  '&:hover': {
    background: disableHover ? 'none' : WsColors.White,
  },
}));

export interface WsFilterDialogProps {
  children: React.ReactNode;
  name: string;
  icon?: React.ReactElement;
  label: string;
  lightMode?: boolean;
  onClick?: (args: string) => void;
  hideButton?: boolean;
}

const WsFilterDialog = ({
  children,
  name,
  icon,
  label,
  onClick,
  lightMode = false,
  hideButton = false,
}: WsFilterDialogProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const handleClickOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick && onClick('onFilterTap');
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  return (
    <Box>
      <Grid item xs={12}>
        <StyledButton
          disableHover={lightMode}
          onClick={handleClickOpen}
          sx={{ justifyContent: 'flex-start' }}
          fullWidth
        >
          <Grid container>
            <Grid item xs={1}>
              <Box pt={1}>{icon}</Box>
            </Grid>
            <Grid item xs={11}>
              <Stack
                direction="column"
                sx={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}
              >
                <Box pl={2}>
                  <Typography
                    color={lightMode ? WsColors.White : WsColors.TertiaryShades600}
                    fontSize="10px"
                    fontWeight="bold"
                  >
                    {label}
                  </Typography>
                </Box>
                <Box pl={2}>
                  <WsTypography
                    cursor="pointer"
                    variant={WsTypoVariants.BODY2}
                    color={lightMode ? WsTypoColors.WHITE : WsTypoColors.BLACK}
                  >
                    {name}
                  </WsTypography>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </StyledButton>
      </Grid>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Grid item xs={10}>
            {children}
          </Grid>
          {!hideButton && (
            <Grid item xs={2}>
              <WsButton
                variant="contained"
                onClick={() => {
                  onClick && onClick('onFilterApply');
                  setAnchorEl(null);
                }}
              >
                Done
              </WsButton>
            </Grid>
          )}
        </Stack>
      </Popover>
    </Box>
  );
};

export default WsFilterDialog;
